var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { Helmet } from 'react-helmet';
import Popup, { Theme } from '../../popup';
import { HeaderNavigationSubmenu, RoundBorders, SubmenuItem, SubmenuItemLink, SubmenuBackground, SubmenuIcon, SubmenuButton } from './Submenu.styles';

var SecondarySubmenu = function SecondarySubmenu(_a) {
  var link = _a.link,
      linkRefs = _a.linkRefs,
      linkId = _a.linkId,
      isMobile = _a.isMobile,
      linkComponent = _a.linkComponent,
      state = __rest(_a, ["link", "linkRefs", "linkId", "isMobile", "linkComponent"]);

  var isMobileMenuOpen = state.isMenuOpen;
  var isCurrentSubmenuOpen = state.headerSubmenu === linkId;
  return /*#__PURE__*/React.createElement(Popup, {
    visible: isCurrentSubmenuOpen,
    onClose: function onClose() {
      if (isCurrentSubmenuOpen) {
        state.setHeaderSubmenu(null);
      }
    },
    enableBackground: true,
    ignoreRefs: linkRefs,
    mobileMenuOpen: isMobileMenuOpen,
    theme: __assign(__assign({}, Theme), {
      Main: HeaderNavigationSubmenu,
      Background: SubmenuBackground
    }),
    "data-test": "header-secondary-" + (isMobile ? 'mobile-' : '') + "submenu",
    "data-test-open": isCurrentSubmenuOpen,
    "data-test-link": linkId
  }, /*#__PURE__*/React.createElement(React.Fragment, null, isCurrentSubmenuOpen && /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("style", {
    type: 'text/css'
  }, "\n              body {\n                overflow: hidden;\n              }\n          ")), /*#__PURE__*/React.createElement(RoundBorders, null, link.submenuItems.map(function (item) {
    var _a, _b;

    return /*#__PURE__*/React.createElement(SubmenuItem, {
      key: item.id
    }, /*#__PURE__*/React.createElement(SubmenuIcon, {
      src: isCurrentSubmenuOpen ? (_a = item === null || item === void 0 ? void 0 : item.icon) === null || _a === void 0 ? void 0 : _a.url : '',
      alt: ((_b = item === null || item === void 0 ? void 0 : item.icon) === null || _b === void 0 ? void 0 : _b.alternativeText) || '',
      loading: 'lazy'
    }), /*#__PURE__*/React.createElement(SubmenuItemLink, {
      as: linkComponent,
      href: item.link
    }, item.label));
  }), link.submenuButton ? /*#__PURE__*/React.createElement(SubmenuButton, {
    linkComponent: linkComponent,
    href: link.submenuButton.link,
    onClick: function onClick() {
      if (isCurrentSubmenuOpen) {
        state.setHeaderSubmenu(null);
      }

      if (isMobileMenuOpen) {
        state.setMenuOpen(false);
      }
    }
  }, link.submenuButton.label) : null)));
};

export default SecondarySubmenu;